import { normalizeMatchRoomCode } from "../../utils/matchRoomCode";

const KEY = "tra.suppressRoomResume";
const TTL_MS = 45_000;

/**
 * After an intentional leave / kick, block auto-resume into the same arena
 * so the session shell cannot loop clearSession → enterResumed → remount.
 * @param {string} roomCode
 */
export function suppressRoomResume(roomCode) {
  const room = normalizeMatchRoomCode(roomCode || "");
  if (!room || typeof sessionStorage === "undefined") return;
  try {
    sessionStorage.setItem(
      KEY,
      JSON.stringify({ room, untilMs: Date.now() + TTL_MS })
    );
  } catch {
    /* ignore */
  }
}

/**
 * @param {string} roomCode
 */
export function isRoomResumeSuppressed(roomCode) {
  const room = normalizeMatchRoomCode(roomCode || "");
  if (!room || typeof sessionStorage === "undefined") return false;
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return false;
    const data = JSON.parse(raw);
    if (!data?.room || data.room !== room) return false;
    if (Date.now() > Number(data.untilMs || 0)) {
      sessionStorage.removeItem(KEY);
      return false;
    }
    return true;
  } catch {
    return false;
  }
}

export function clearRoomResumeSuppress() {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
}
